export const BLUECONIC_SITES = [
  '36', // '12th Man Rising'
  '304', // '1428 Elm'
  '29', // 'Air Alamo'
  '225', // "All Coug'd Up"
  '212', // 'All for Tennessee'
  '389', // 'All Stoked Up'
  '369', // 'Wizards And Whatnot'
  '115', // 'All U Can Heat'
  '509', // 'Along Main Street'
  '105', // '8 Points, 9 Seconds'
  '366', // 'Amazon Adviser'
  '353', // 'Americans Undercover'
  '333', // 'App Trigger'
  '40', // 'Around the Foghorn'
  '88', // 'A Royal Pain'
  '130', // 'Arrowhead Addict'
  '346', // 'Art of Gears'
  '265', // 'ATL All Day'
  '344', // 'AudioPhix'
  '168', // 'Autzen Zoo'
  '160', // 'A Winning Habit'
  '146', // 'Badger of Honor'
  '187', // 'Bama Hammer'
  '308', // 'Bam Smack Pow'
  '391', // 'Bayern Strikes'
  '227', // 'Beale Street Bears'
  '60', // 'Bear Goggles On'
  '197', // 'Beaver Byte'
  '94', // 'Behind the Buck Pass'
  '426', // 'BetSided'
  '243', // 'Beyond the Flag'
  '175', // 'Ball Durham'
  '238', // 'Big Red Louie'
  '11', // 'Birds Watcher'
  '55', // 'Black and Teal'
  '99', // 'Blackhawk Up'
  '124', // 'Blackout Dallas'
  '125', // 'Blades of Teal'
  '104', // 'Bleedin' Blue'
  '44', // 'Blogging Dirty'
  '359', // 'Blog of Legends'
  '64', // 'Blog Red Machine'
  '100', // 'Blue Line Station'
  '41', // 'Blue Man Hoop'
  '236', // 'Boiling With Bias'
  '13', // 'Bolt Beat'
  '23', // 'Bolts by the Bay'
  '14', // 'BoSox Injection'
  '72', // 'Broad Street Buzz'
  '522', // 'Buckets in Brooklyn'
  '16', // 'BuffaLowDown'
  '184', // 'Busting Brackets'
  '395', // 'BVB Buzz'
  '135', // 'Call to the Pen'
  '200', // 'Canes Warning'
  '314', // 'Caped Crusades'
  '19', // 'Stars and Sticks'
  '114', // 'Cardiac Cane'
  '92', // 'Cat Crave'
  '74', // 'Causeway Crowd'
  '520', // 'Chicago Sky Daily'
  '133', // 'Friars on Base'
  '270', // 'Chop Chat'
  '253', // 'Chowder and Champions'
  '189', // 'Cincy on the Prowl'
  '365', // 'Claire and Jamie'
  '387', // 'Claret Villans'
  '141', // 'Climbing Tal\'s Hill'
  '81', // 'Clipperholics'
  '9', // 'Cubbies Crib'
  '386', // 'Culturess'
  '87', // 'Daily DDT'
  '27', // 'Daily Knicks'
  '325', // 'Dairyland Express'
  '56', // 'Dawg Pound Daily'
  '258', // 'Da Windy City'
  '153', // 'Dawn of the Dawg'
  '506', // 'DBLTAP'
  '241', // 'Dear Old Gold'
  '162', // 'Death Valley Voice'
  '196', // 'Detroit Jock City'
  '261', // 'Devils in Detail'
  '374', // 'Dire Dota'
  '95', // 'District on Deck'
  '342', // 'Doctor Who Watch'
  '75', // 'Dodgers Way'
  '319', // 'Dork Side of the Force'
  '91', // 'Dunking with Wolves'
  '26', // 'Ebony Bird'
  '121', // 'Editor In Leaf'
  '210', // 'Empire Writes Back'
  '392', // 'Everything Barca'
  '305', // 'Everything On Tap'
  '360', // 'Eye On Bond'
  '111', // 'Eyes On Isles'
  '251', // 'Factory of Sadness'
  '501', // 'FanSided ES'
  '127', // 'Fantasy CPR'
  '233', // 'Fighting Gobbler'
  '117', // 'Flame for Thought'
  '277', // 'FlickSided'
  '215', // 'Fly War Eagle'
  '306', // 'FoodSided'
  '421', // 'Forever Fortnite'
  '324', // 'Four Four Crew'
  '388', // 'Foxes of Leicester'
  '155', // 'Nothin\' But Nets'
  '281', // 'GameSided'
  '244', // 'Garnet and Cocky'
  '148', // 'GBMWolverine'
  '317', // 'GeekSided'
  '273', // 'Gig Em Gazette'
  '268', // 'Glory Colorado'
  '31', // 'GMEN HQ'
  '202', // 'Go Joe Bruin'
  '250', // 'Gold and Gopher'
  '185', // 'Golden Bear Lair'
  '246', // 'Golden Gate Sports'
  '103', // 'Gone Puck Wild'
  '158', // 'Green, Gold, and Bold'
  '382', // 'Green Street Hammers'
  '405', // 'Guilty Eats'
  '213', // 'Hail Florida Hail'
  '138', // 'Hail WV'
  '107', // 'Halo Hangout'
  '18', // 'Hardwood Houdini'
  '357', // 'Show Snob'
  '280', // 'Hidden Remote'
  '403', // 'High Post Hoops'
  '112', // 'Jets White Out'
  '245', // 'Hook\'em Headlines'
  '307', // 'Hoops Habit'
  '152', // 'Hoosier State of Mind'
  '47', // 'Horseshoe Heroes'
  '208', // 'Hotspur HQ'
  '279', // 'House of Houston'
  '126', // 'Howlin\' Hockey'
  '217', // 'Hoyos Revenge'
  '260', // 'The Summit'
  '147', // 'Husker Corner'
  '519', // 'Indiana Fever Report'
  '283', // 'Ink on Indy'
  '396', // 'Inside Ibrox'
  '57', // 'Inside the Iggles'
  '177', // 'Inside the Loud House'
  '502', // 'Inter Heron'
  '39', // 'Jays Journal'
  '172', // 'Jug of Snyder'
  '28', // 'Just Blog Baby'
  '363', // 'Kardashian Dish'
  '220', // 'KC Kingdom'
  '206', // 'Keeping It Heel'
  '7', // 'Kings of Kauffman'
  '518', // 'Knightly Review'
  '425', // 'Kraken Chronicle'
  '20', // 'Lake Show Life'
  '195', // 'LA Sports Hub'
  '361', // 'Last Night On'
  '278', // 'Lawless Republic'
  '350', // 'Lob and Smash'
  '51', // 'Lombardi Ave'
  '347', // 'Man City Square'
  '86', // 'Marlin Maniac'
  '296', // 'Maroon and White Nation'
  '108', // 'Mile High Sticking'
  '330', // 'MLS Multiplex'
  '66', // 'Motor City Bengals'
  '49', // 'Musket Fire'
  '340', // 'Netflix Life'
  '354', // 'Newcastle Toons'
  '25', // 'NFL Mocks'
  '136', // 'NFL Spin Zone'
  '42', // 'Niner Noise'
  '132', // 'Nolan Writin\''
  '313', // 'Northbank RSL'
  '78', // 'Nugg Love'
  '76', // 'Octopus Thrower'
  '156', // 'Oil On Whyte'
  '424', // 'Old Juve'
  '256', // 'Old North Banter'
  '214', // 'Ole Hotty Toddy'
  '398', // 'One Chicago Center'
  '326', // 'Orange In The Oven'
  '38', // 'Orlando Magic Daily'
  '316', // 'O-Town\'s 11'
  '209', // 'Pain in the Arsenal'
  '73', // 'Pelican Debrief'
  '97', // 'Pens Labyrinth'
  '62', // 'Phin Phanatic'
  '24', // 'Pippen Ain\'t Easy'
  '67', // 'PistonPowered'
  '207', // 'Playing for 90'
  '266', // 'Pokes Post'
  '422', // 'Precinct TV'
  '159', // 'Predlines'
  '46', // 'Predominantly Orange'
  '327', // 'Prince Rupert\'s Tower'
  '120', // 'Pro Golf Now'
  '503', // 'PSG Post'
  '2', // 'Puckett\'s Pond'
  '89', // 'Pucks and Pitchforks'
  '110', // 'Pucks of a Feather'
  '123', // 'The J-Notes'
  '32', // 'Raising Zona'
  '54', // 'Ramblin\' Fan'
  '85', // 'Raptors Rapture'
  '21', // 'Rays Colored Glasses'
  '218', // 'Razorbackers'
  '33', // 'Redbird Rants'
  '292', // 'Red Devil Armada'
  '521', // 'Red Devils Dispatch'
  '370', // 'Redshirts Always Die'
  '144', // 'Reign of Troy'
  '423', // 'Release The Knappen'
  '338', // 'Reporting KC'
  '80', // 'Reviewing the Brew'
  '289', // 'Rhyme Junkie'
  '61', // 'Riggo\'s Rag'
  '164', // 'King James Gospel'
  '70', // 'Rink Royalty'
  '34', // 'Rip City Project'
  '3', // 'Rising Apple'
  '113', // 'Rox Pile'
  '293', // 'Rubbing the Rock'
  '4', // 'Rum Bunter'
  '287', // 'Rush The Kop'
  '12', // 'Sabre Noise'
  '390', // 'Saints Marching'
  '194', // 'Saturday Blitz'
  '151', // 'Scarlet and Game'
  '190', // 'Section 215'
  '96', // 'SenShot'
  '53', // 'SideLion Report'
  '82', // 'Sir Charles In Charge'
  '336', // 'Skyscraper Blues'
  '167', // 'Slap the Sign'
  '131', // 'Soaring Down South'
  '176', // 'Soaring to Glory'
  '65', // 'SoDo Mojo'
  '166', // 'Sounders Nation'
  '356', // 'South Bound & Down'
  '134', // 'Southside Showdown'
  '178', // 'Space City Scoop'
  '137', // 'Spartan Avenue'
  '181', // 'Sports Dallas Fort-Worth'
  '345', // 'Stairway to 11'
  '58', // 'Still Curtain'
  '154', // 'Stormin in Norman'
  '291', // 'Storm The Paint'
  '59', // 'Stripe Hype'
  '399', // 'Surviving Tribal'
  '179', // 'Swarm and Sting'
  '101', // 'White Cleat Beat'
  '512', // 'Tea and Banter'
  '334', // 'Tenn Truth'
  '174', // 'Terrapin Station'
  '6', // 'That Balls Outta Here'
  '109', // 'The Canuck Way'
  '393', // 'The Celtic Bhoys'
  '163', // 'The Husky Haul'
  '30', // 'The Jet Press'
  '129', // 'The Landry Hat'
  '511', // 'The Parent Watch'
  '50', // 'The Pewter Plank'
  '310', // 'The Pride of London'
  '102', // 'The Rat Trick'
  '384', // 'The Real Champs'
  '98', // 'The Sixer Sense'
  '83', // 'The Smoking Cuban'
  '504', // 'The Timber Lean'
  '524', // 'The Valkyries Blog'
  '247', // 'The View from Avalon'
  '63', // 'The Viking Age'
  '169', // 'Through the Phog'
  '157', // 'Thunderous Intentions'
  '285', // 'Tip of the Tower'
  '35', // 'Titan Sized'
  '17', // 'House That Hank Built'
  '142', // 'Puck Prose'
  '368', // 'Toronto Reds'
  '10', // 'Toro Times'
  '312', // 'TripSided'
  '320', // 'True Detective Rumors'
  '171', // 'Truman\'s Tales'
  '318', // 'Undead Walking'
  '410', // 'Under the Laces'
  '118', // 'Union and Blue'
  '69', // 'Valley of the Suns'
  '8', // 'Venom Strikes'
  '139', // 'Victory Bell Rings'
  '419', // 'Viva Liga MX'
  '5', // 'Away Back Gone'
  '211', // 'The Top Flight'
  '315', // 'Whatever A Spider Can'
  '15', // 'Who Dat Dish'
  '198', // 'Wildcat Blue Nation'
  '385', // 'Winter is Coming'
  '182', // 'With the First Pick'
  '150', // 'Wiz of Awes'
  '275', // 'Wreck\'Em Red'
  '140', // 'Writing Illini'
  '43', // 'Yanks Go Yard'
  '295', // 'Yellow Jacked Up'
  '201', // 'Zona Zealots'
];
